import gql from "graphql-tag";

export const MY_TIME_GET_MESSAGES_LIST = gql`
  query getMyTimeMessagesList($request: String!) {
    getMyTimeMessagesList(request: $request) {
      _id
      request
      message
      createdAt
      createdBy
      employeeName
    }
  }
`;
